/** Calendar adapter. Civil dates use UTC internally; the order clock uses the profile timezone. */
(() => {
  'use strict';
  const DAY = 86400000;
  const date = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) throw new Error('Invalid calendar date');
    const result = new Date(`${value}T12:00:00Z`);
    if (Number.isNaN(result.valueOf()) || iso(result) !== value) throw new Error('Invalid calendar date');
    return result;
  };
  const iso = value => value.toISOString().slice(0, 10);
  const add = (value, days) => new Date(value.valueOf() + days * DAY);
  function easter(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
    return new Date(Date.UTC(year, Math.floor(n / 31) - 1, n % 31 + 1, 12));
  }
  // Current statutory rules, reviewed 2026-10-20. Sources/municipal caveats: README D-01.
  const germanRegions = {
    BW: ['01-06', '11-01'], BY: ['01-06', '08-08', '08-15', '11-01'],
    BE: ['03-08'], BB: ['10-31'], HB: ['10-31'], HH: ['10-31'],
    HE: [], MV: ['03-08', '10-31'], NI: ['10-31'], NW: ['11-01'],
    RP: ['11-01'], SL: ['08-15', '11-01'], SN: ['10-31'],
    ST: ['01-06', '10-31'], SH: ['10-31'], TH: ['09-20', '10-31']
  };
  function localHolidays(country, region, year) {
    if (!Number.isInteger(year) || year < 2026 || year > 2099) throw new Error('Calendar year outside supported range');
    const fixed = ['01-01', '05-01', '12-25', '12-26'];
    const offsets = [1, 39, 50];
    const sunday = easter(year);
    if (country === 'AT' && (!region || /^AT-[1-9]$/.test(region))) {
      fixed.push('01-06', '08-15', '10-26', '11-01', '12-08');
      offsets.push(60);
    } else if (country === 'DE' && (!region || Object.prototype.hasOwnProperty.call(germanRegions, region.slice(3)) && region.startsWith('DE-'))) {
      const state = region?.slice(3);
      fixed.push('10-03', ...(state ? germanRegions[state] : Object.values(germanRegions).flat()));
      offsets.push(-2);
      // Municipal-only holidays are a conservative state union until municipality data exists.
      if (!state || ['BW', 'BY', 'HE', 'NW', 'RP', 'SL', 'SN', 'TH'].includes(state)) offsets.push(60);
      if (!state || state === 'BB') offsets.push(0, 49);
      if (!state || state === 'SN') {
        let repentance = date(`${year}-11-22`);
        while (repentance.getUTCDay() !== 3) repentance = add(repentance, -1);
        fixed.push(iso(repentance).slice(5));
      }
    } else throw new Error('No supported local holiday calendar');
    return new Set([...fixed.map(day => `${year}-${day}`), ...offsets.map(days => iso(add(sunday, days)))]);
  }
  async function load(country, region, years) {
    const dates = new Set();
    years.forEach(year => localHolidays(country, region, year).forEach(day => dates.add(day)));
    return { dates, fallback: false };
  }
  const api = { date, iso, add, localHolidays, load };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else window.DeliveryCalendar = window.DeliveryCalendar || api;
})();
